import React from 'react';
import { IIconProps } from '../interfaces';

const AskWavesIcon = (props: IIconProps) => {
    return (
        <svg
            className={ props.classes ?? undefined }
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 24 24"
            width="15"
            height="15">
            <path fill="#FFFFFF" d="M10 3l1.6 5.4L17 10l-5.4 1.6L10 17l-1.6-5.4L3 10l5.4-1.6z"/>
            <path fill="#FFFFFF" d="M18.5 14l.8 2.2 2.2.8-2.2.8-.8 2.2-.8-2.2-2.2-.8 2.2-.8z"/>
        </svg>
    )
};

export default AskWavesIcon;